import { useQuery } from '@tanstack/react-query';

import { useGetCheckout, getQueryKeyForGetCheckout } from 'state/upscribe/getCheckout';
import UpscribeRequestError from 'state/hooks/useUpscribeRequest/utils/upscribeRequestError';

import { useRouter } from 'next/router';
import { useCartCheckoutToken } from './useCartCheckoutToken';

export const useGetCartCheckout = () => {
  const [, setToken] = useCartCheckoutToken();
  const getCheckout = useGetCheckout();

  return async ({ token }: { token: string }) => {
    try {
      const checkout = await getCheckout({ token });

      return checkout;
    } catch (error) {
      if (error instanceof UpscribeRequestError && error.status === 404) {
        setToken(null);
      }

      throw error;
    }
  };
};

export const useQueryGetCartCheckout = () => {
  const getCartCheckout = useGetCartCheckout();
  const [getToken] = useCartCheckoutToken();
  const token = getToken();
  const { pathname: routerPathname } = useRouter();

  return useQuery({
    enabled: Boolean(token),
    queryKey: getQueryKeyForGetCheckout(token!, routerPathname),
    queryFn: () => getCartCheckout({ token: token! })
  });
};
